/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback, memo, forwardRef, useImperativeHandle } from 'react';
import { getOrganismoEmisorHabilitado } from '../../componentes/http/actions/OrganismoEmisorAction';
import { getTipoDocumentoHabilitado } from '../../componentes/http/actions/TipoDocumentoAction';
import { getEstadoTramitacionHabilitado } from '../../componentes/http/actions/EstadoTramitacionAction';
import { getRubroHabilitado } from '../../componentes/http/actions/RubroAction';
import { getClasificacionDocumentoHabilitado } from '../../componentes/http/actions/ClasificacionDocumentoAction';
import { getClienteHabilitado } from '../../componentes/http/actions/ClientesAction';
import { getPaisHabilitado } from '../http/actions/PaisAction';

const DataLoader = forwardRef(({ onDataLoaded }, ref) => {
  const [dataLoaded, setDataLoaded] = useState(false);

  const loadData = useCallback(async () => {
    try {
      const [
        clasificaciones,
        estadosTramitacion,
        organismos,
        rubros,
        tiposDocumento,
        clientes,
        paises
      ] = await Promise.all([
        getClasificacionDocumentoHabilitado(localStorage.getItem('token')),
        getEstadoTramitacionHabilitado(localStorage.getItem('token')),
        getOrganismoEmisorHabilitado(localStorage.getItem('token')),
        getRubroHabilitado(localStorage.getItem('token')),
        getTipoDocumentoHabilitado(localStorage.getItem('token')),
        getClienteHabilitado(localStorage.getItem('token')),
        getPaisHabilitado(localStorage.getItem('token'))
      ]);

      onDataLoaded({
        clasificaciones,
        estadosTramitacion,
        organismos,
        rubros,
        tiposDocumento,
        clientes,
        paises
      });
      setDataLoaded(true);
    } catch (error) {
      console.error("Error loading data:", error);
    }
  }, [onDataLoaded]);

  // Exponer el método loadData a través de la ref
  useImperativeHandle(ref, () => ({
    loadData
  }));

  useEffect(() => {
    loadData();
  }, [loadData]);

  return null;
});

export default memo(DataLoader);